import React, { useState, useEffect } from "react";
import Sidebar from "../Components/OurDashboardComponent/Sidebar";
import MainContainer from "../Components/OurDashboardComponent/MainContainer";
import { Box, createTheme, Stack, ThemeProvider, Avatar } from "@mui/material";
import "../Styles/OurDashboard/Dashboard.css";

const OurDashboard = ({ isMain, type }) => {
  const [mode, setMode] = useState("light");
  const [showSidebar, setShowSidebar] = useState(false);

  const theme = createTheme({
    palette: {
      mode: mode,
      // primary: {
      //   main: mode == "dark" ? "#0ff0ff" : "#ff0000",
      // },
      // secondary: {
      //   main: "#0000ff",
      // },
      // otherColor: {
      //   main: "#0000ff",
      // },
      bgPrimary: {
        // main: "#fff",
        main: mode == "light" ? "#fff" : "rgb(0,30,60)",
      },
      bgSecondary: {
        // main: "#fafafb",
        main: "#0a1929",
        main: mode == "light" ? "#fafafb" : "#0a1929",
      },
      fontPrimaryColor: {
        // main: "#262626",
        // main: "#fff",
        main: mode == "light" ? "#262626" : "#f5f5f5",
      },
      fontSecondaryColor: {
        // main: "#8c8c8c",
        // main: "#f6f6f6",
        main: mode == "light" ? "#8c8c8c" : "#f6f6f6",
      },
      buttonBgColor: {
        main: "#052728",
      },
      ourRedColor: {
        main: "#db1010",
      },
      ourOrangeColor: {
        main: "#e36a18",
      },
      ourGreenColor: {
        main: "#22b55a",
      },
      rBlueColor: {
        main: "#2d79db",
      },
      rYellowColor: {
        main: "#fcc432",
      },
      rRedColor: {
        main: "#ec544c",
      },
      rPurpleColor: {
        main: "#985ceb",
      },

      logoColorShade: {
        main: "#09e08d36",
      },
      borderRadius: {
        main: "8px",
      },
    },
    font: {
      primaryFont: {
        main: "public sans",
      },
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <Box
        className="our__dasboard__page"
        sx={{ display: "flex", overflow: "hidden" }}
      >
        <Sidebar
          mode={mode}
          setMode={setMode}
          showSidebar={showSidebar}
          setShowSidebar={setShowSidebar}
        />
        <MainContainer
          mode={mode}
          showSidebar={showSidebar}
          setShowSidebar={setShowSidebar}
          type={type}
        />
        <Box
          className="sidebar__cover"
          sx={{ left: !showSidebar ? "-120%" : "0" }}
        ></Box>
      </Box>
    </ThemeProvider>
  );
};

export default OurDashboard;
